import { render, staticRenderFns } from "./MyPageItem.vue?vue&type=template&id=9537c4da&scoped=true"
import script from "./MyPageItem.vue?vue&type=script&lang=js"
export * from "./MyPageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9537c4da",
  null
  
)

export default component.exports